module.exports = __webpack_public_path__ + "media/images/right-icon-6ef69031.png";